import { lkMore } from "./ai-more/index.js";

export const initAiSkin = () => {
    lkMore();
};
